import {
  // setUser,
  // setInvitationUser,
  addUser,
  removeUser,
  updateUser,
} from "stores/slice/bogus/userManagement/on-prem/const";

const onPremOrgUserManagementConfig = {
  // List Org Users
  "onPrem/orgs/:orgId/users.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/users",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "onPremUserManagement.users",
  },

  // Remove an Org User
  "onPrem/orgs/:orgId/users/:userId.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/users/:userId",
    restful: true,
    method: "delete",
    buildParams: (params) => ({
      orgId: params.orgId,
      userId: params.userId,
    }),
    action: removeUser,
    mockSelector: "onPremUserManagement.users",
  },

  // Create an org user
  "onPrem/orgs/:orgId/users.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/users",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: addUser,
    mockSelector: "onPremUserManagement.users",
  },

  // Update an Org User
  "onPrem/orgs/:orgId/users/:userId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/users/:userId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: updateUser,
    mockSelector: "onPremUserManagement.users",
  },
};

export default onPremOrgUserManagementConfig;
